'use client'
import { FadeIn } from '@/components/ui/animation/faideIn'
import { buttonVariantsPartner } from '@/components/ui/button'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'
import { FiArrowUpRight } from 'react-icons/fi'

const JoinUs = () => {
  const { session } = useAuth()
  return (
    <>
      <div className="max-w-7xl mx-auto mainpartner bg-red-700 px-5 py-[60px]">
        <div className="flex justify-center">
          <p className="font-semibold text-[48px] leading-[60px] text-center text-white lg:w-[770px]">
            Join Us
          </p>
        </div>
        <div className="flex justify-center flex-col items-center mt-4">
          <p className="text-[20px] font-normal leading-[30px] text-white lg:w-[770px] text-center">
            Our team is committed to forging the next generation of AI leaders.
            If you're ready to embrace rigorous challenges and leverage elite
            connections, AI Forge is where your transformation begins.
          </p>
          <p className="text-[20px] font-normal leading-[30px] text-white lg:w-[770px] text-center mt-8">
            Have questions or want to learn more about our team?
            <div className="text-white font-[700] text-[22px] ">
              Contact Us: info@aiforge.org
            </div>
          </p>
        </div>
        <FadeIn className="hidden flex-col flex md:flex-row justify-center gap-4 mt-10 items-center">
          <Link
            href={'/about'}
            className={cn(
              buttonVariantsPartner({
                size: '2xl',
                variant: 'secondary',
              }),
              'border-[#155EEF] bg-white/10 mt-3 sm:mt-0',
            )}
          >
            About Program
            <FiArrowUpRight className="text-white text-xl md:text-2xl leading-7 ml-1 md:ml-3.5" />
          </Link>
          <Link
            href={`${getApplyRedirectUrl(session)}`}
            className={buttonVariantsPartner({ size: '2xl' })}
          >
            Apply Now
            <FiArrowUpRight className="text-[#18181B] text-xl md:text-2xl leading-7 ml-1 md:ml-3.5 " />
          </Link>
        </FadeIn>
        {/* <div className="flex-col flex md:flex-row justify-center gap-4 mt-10 items-center">
          <Link
            href="/about"
            className="bg-white bg-opacity-10 gap-3 flex justify-center items-center px-5 w-full
                    text-[#fff] text-[18px] font-semibold leading-[28px] rounded border border-transparent	 hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF] 
                    md:w-[225px] h-[60px] text-center -m-1.5 p-1.5"
          >
            Our Program
            <FiArrowUpRight className="text-[#fff] text-[18px] font-semibold leading-[28px]" />
          </Link>
          <Link
            href="/signup"
            className="bg-white bg-opacity-10 gap-3 flex justify-center items-center px-5 w-full
                    text-[#fff] text-[18px] font-semibold leading-[28px] text-center rounded border border-transparent	 hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF] md:w-[225px] h-[60px] mt-4 sm:mt-0"
          >
            Register
            <FiArrowUpRight className="text-[#fff] text-[18px] font-semibold leading-[28px]" />
          </Link>
        </div> */}
        {/* modal box code  */}
        {/* <Modal showModal={showModal} setShowModal={setShowModal} /> */}

        {/* end */}
      </div>
    </>
  )
}

export default JoinUs
